import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveResourceFromProjectRequestFailure(project, projectResource) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          projectResource.uuid === res.projectResource.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveResourceFromProjectRequestPending(project, projectResource) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          projectResource.uuid === res.projectResource.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveResourceFromProjectRequestSuccess(project, projectResource) {
      const state = getState().find(
        (res) =>
          res.project.uuid === project.uuid &&
          projectResource.uuid === res.projectResource.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
